import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { User } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-assignee-modal',
  templateUrl: './update-assignee-modal.component.html',
  styleUrls: ['./update-assignee-modal.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class UpdateAssigneeModalComponent {

  public assignee: User = null;
  public pendencyId = '';

  constructor(
    public readonly matDialogRef: MatDialogRef<null>,
    private readonly translateService: TranslateService,
    private readonly customMessageService: CustomMessagesService,
    @Inject(MAT_DIALOG_DATA) public readonly data: { id: string, assignee: User },
  ) {
    this.assignee = this.data.assignee;
    this.pendencyId = this.data.id;
  }

  public closeModal(): void {
    this.matDialogRef.close();
  }

  public closeDialogEvent(event: any): void {
    if (!event.detail) {
      this.closeModal();
      return;
    }

    const pendency = event.detail.pendency;

    if (pendency && pendency.assignee) {
      this.customMessageService.success(
        this.translateService.instant(`MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.MESSAGES.${event.detail.message}`)
      );
    } else if (event.detail.error === 'UPDATE_ASSIGNEE_ERROR') {
      this.customMessageService.error(
        this.translateService.instant(`MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.MESSAGES.${event.detail.message}`)
      );
    }

    if (pendency && !pendency.assignee && !event.detail.error) {
      this.customMessageService.success(
        this.translateService.instant(`MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.REMOVE_ASSIGNEE_MODAL.${event.detail.message}`)
      );
    } else if (event.detail.error === 'REMOVE_ASSIGNEE_ERROR') {
      this.customMessageService.error(
        this.translateService.instant(`MAINTENANCES.TABS.PENDENCIES.UPDATE_PENDENCY_ASSIGNEE.REMOVE_ASSIGNEE_MODAL.${event.detail.message}`)
      );
    }

    this.matDialogRef.close(event.detail);
  }

  public showDialog(): void {
    const dialogElement: any = this.matDialogRef;
    if (this.matDialogRef._containerInstance) {
      const containerDiv = dialogElement._containerInstance._elementRef.nativeElement;
      containerDiv.style.opacity = 1;
      containerDiv.style.transition = 'opacity 0.2s';

      const backdrop: any = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop) {
        backdrop.style.display = 'block';
      }
    }
  }

  public hideDialog(): void {
    const dialogElement: any = this.matDialogRef;
    if (this.matDialogRef._containerInstance) {
      const containerDiv = dialogElement._containerInstance._elementRef.nativeElement;
      containerDiv.style.opacity = 0;
      containerDiv.style.transition = 'opacity 0.2s';

      const backdrop: any = document.querySelector('.cdk-overlay-backdrop');
      if (backdrop) {
        backdrop.style.display = 'none';
      }
    }
  }
}
